var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.selectedValue,"options":_vm.options,"fieldNames":{ label: 'name', value: 'id', children: 'children' },"placeholder":"请选择经营组及对接人"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }